module.exports = __webpack_public_path__ + "img/mandatory-certification.397f468b.png";